// Message for a seat booking that was cancelled because another guest paid for
// the same seats first. `seatBooking` comes from GET /payments/guest/:token.
export const seatsTakenMessage = ({ seatLabels = [], refunded, refundFailed }) => {
  const labels = seatLabels.join(', ');
  if (refundFailed) {
    return `Sorry, another guest paid for seat(s) ${labels} a moment before you. Your booking was cancelled and the venue will refund your payment.`;
  }
  if (refunded) {
    return `Sorry, another guest paid for seat(s) ${labels} a moment before you. Your booking was cancelled and your payment has been refunded.`;
  }
  // Nothing was charged (stopped before checkout).
  return `Sorry, seat(s) ${labels} were just booked by another guest. Please go back and pick other seats.`;
};

// The booking was already cancelled (for some other reason) when the payment went
// through, so it was refunded automatically. Same `seatBooking` object.
export const bookingCancelledMessage = ({ refundFailed } = {}) => {
  if (refundFailed) {
    return 'This booking had already been cancelled when your payment went through. The venue will refund your payment.';
  }
  return 'This booking had already been cancelled when your payment went through, so your payment has been refunded.';
};
